import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { ForwardFeedbackModalState, ForwardFeedbackModalStore } from './forward-feedback-modal.store';

@Injectable({ providedIn: 'root' })
export class ForwardFeedbackModalQuery extends Query<ForwardFeedbackModalState> {
  constructor(protected store: ForwardFeedbackModalStore) {
    super(store);
  }
  selectLoading() {
    return this.select('loading');
  }

  selectFailed() {
    return this.select('failed');
  }

  selectErrMsgs() {
    return this.select('errMsgs');
  }

  selectAccounts() {
    return this.select('accounts');
  }
}
